import { Controller } from "stimulus"

// Bugfix 17 (#1352), #1856: de linkernavigatie. Sinds #1856 staan daar alleen
// de hoofdcategorieën, als gewone links; uitklappen is er niet meer. Wat hier
// overblijft: tijdens de onboarding (#1562) navigeert een klik op een
// vergrendelde categorie niet, er verschijnt een melding en de gebruiker
// blijft op de pagina.
export default class extends Controller {
  static targets = ["melding"]

  disconnect() {
    clearTimeout(this.meldingTimer)
  }

  vergrendeld(event) {
    event.preventDefault()
    if (!this.hasMeldingTarget) return

    this.meldingTarget.hidden = false
    clearTimeout(this.meldingTimer)
    this.meldingTimer = setTimeout(() => this.sluitMelding(), 6000)
  }

  sluitMelding() {
    if (this.hasMeldingTarget) this.meldingTarget.hidden = true
  }
}
